module.exports = __webpack_public_path__ + "img/banner-academia-mobile.88d2afca.png";